import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as ErrorMessage from "../../common/errorMessage"
import * as Regex from "../../common/regex"
import * as Alert from "../../services/sweetalertService"
import * as API from "../../services/httpService"
import { navigate } from "gatsby"
import { Row, Col } from "react-bootstrap"
import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormRadioButton from "../shared/formRadioButton"
import {
  pageIncrement,
  updateClickedNext,
  updateValidFormData,
  controlLoading,
  updateUiData,
} from "../../redux/actions"
import { useDispatch, batch } from "react-redux"

const PolicyInformation = ({ claimData, uiData }) => {
  // console.log("PolicyInformation rendered!")
  const { pageNumber, clickedNext, hideHeaderFooter } = uiData

  const dispatch = useDispatch()
  const policyFormRef = React.useRef()

  const policyInfoSchema = Yup.object().shape({
    policyNumber: Yup.string()
      .required(ErrorMessage.policyNumber)
      .matches(Regex.policyPattern, ErrorMessage.policyNumber),

    policyHolderName: Yup.string()
      .required(ErrorMessage.policyHolderName)
      .matches(Regex.namepattern, ErrorMessage.policyHolderName),

    policyHolderEmail: Yup.string()
      .required(ErrorMessage.policyHolderEmail)
      .email(ErrorMessage.policyHolderEmail),

    policyHolderTel: Yup.string()
      .required(ErrorMessage.policyHolderTel)
      .matches(Regex.mobilepattern, ErrorMessage.policyHolderTel),

    otherInsurance: Yup.string().when("isOtherInsuranceCovering", {
      is: isOtherInsuranceCovering => isOtherInsuranceCovering,
      then: Yup.string().required(ErrorMessage.otherInsurance),
    }),

    claimantName: Yup.string()
      .required(ErrorMessage.claimantName)
      .matches(Regex.namepattern, ErrorMessage.claimantName),

    claimantEmail: Yup.string()
      .required(ErrorMessage.claimantEmail)
      .email(ErrorMessage.claimantEmail),

    claimantMobile: Yup.string()
      .required(ErrorMessage.claimantMobile)
      .matches(Regex.mobilepattern, ErrorMessage.claimantMobile),
  })

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimLiabilityDetail"])}
      enableReinitialize={true}
      validationSchema={policyInfoSchema}
      validateOnMount={true}
      innerRef={policyFormRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, isValid, values, errors }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row className={pageNumber === 1 ? "" : "hide"}>
            <div
              className={
                "title text-center " +
                " " +
                (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
              }
            >
              Submit online liability claim
            </div>
            <Row className={"containerBody marginTop3x"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " + (pageNumber !== 1 ? "hide" : "")
                      }
                    >
                      Policy Information
                    </div>
                  </Col>
                </div>
                <div>
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Policy Number"}
                    maxLength={20}
                    name="policyNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Policy Holder Name"}
                    maxLength={100}
                    name="policyHolderName"
                    component={FormTextbox}
                    toUpperCase={true}
                  />
                  <Field
                    textDesc={"Policyholder's Email"}
                    maxLength={100}
                    name="policyHolderEmail"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={"Policyholder's Telephone Number"}
                    maxLength={9}
                    name="policyHolderTel"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                  <Field
                    textDesc={
                      "Do you have other insurance covering you in respect of this accident?"
                    }
                    name="isOtherInsuranceCovering"
                    component={FormRadioButton}
                  />
                  {values.isOtherInsuranceCovering && (
                    <>
                      {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                      <Field
                        textDesc={"Disable Auto Complete"}
                        name="disableAutoComplete2"
                        component={FormFieldDisableAutoComplete}
                      />
                      <Field
                        textDesc="Please provide details of other insurance."
                        maxLength={300}
                        name="otherInsurance"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                    </>
                  )}
                </div>
              </Col>
            </Row>

            <Row className={"containerBody marginTop3x "}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " + (pageNumber !== 1 ? "hide" : "")
                      }
                    >
                      Claimant Details
                    </div>
                  </Col>
                </div>
                <div>
                  <Field
                    textDesc={"Claimant is policy holder?"}
                    name="claimantIsPolicyHolder"
                    component={FormRadioButton}
                  />
                  {!values.claimantIsPolicyHolder && (
                    <>
                      {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                      <Field
                        textDesc={"Disable Auto Complete"}
                        name="disableAutoComplete3"
                        component={FormFieldDisableAutoComplete}
                      />
                      <Field
                        textDesc={"Claimant Full Name"}
                        maxLength={20}
                        name="claimantName"
                        component={FormTextbox}
                        toUpperCase={true}
                      />
                      <Field
                        textDesc={"Claimant Email"}
                        maxLength={100}
                        name="claimantEmail"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                      <Field
                        textDesc={"Claimant Telephone Number"}
                        maxLength={9}
                        name="claimantMobile"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Row>
          <HandleFormValidation
            currentPageClickedNext={clickedNext[1]}
            policyFormRef={policyFormRef}
            values={values}
            pageNumber={1}
            dispatch={dispatch}
          />
          <HandleClaimantIsPolicyholder
            policyFormRef={policyFormRef}
            claimantIsPolicyHolder={values.claimantIsPolicyHolder}
          />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleClaimantIsPolicyholder = ({
  policyFormRef,
  claimantIsPolicyHolder,
}) => {
  React.useEffect(() => {
    //If clciked claimantIsPolicyHolder false will clear the 3 fields below
    if (!claimantIsPolicyHolder) {
      policyFormRef.current.setFieldValue("claimantName", "")
      policyFormRef.current.setFieldValue("claimantEmail", "")
      policyFormRef.current.setFieldValue("claimantMobile", "")
    }
  }, [claimantIsPolicyHolder])
  return null
}

const HandleFormValidation = ({
  currentPageClickedNext,
  policyFormRef,
  values,
  pageNumber,
  dispatch,
}) => {
  React.useEffect(() => {
    if (values.claimantIsPolicyHolder) {
      policyFormRef.current.setFieldValue(
        "claimantName",
        values.policyHolderName
      )
      policyFormRef.current.setFieldValue(
        "claimantEmail",
        values.policyHolderEmail
      )
      policyFormRef.current.setFieldValue(
        "claimantMobile",
        values.policyHolderTel
      )
    }
    if (currentPageClickedNext) {
      policyFormRef.current.validateForm().then(errors => {
        // console.log(errors)
        if (Object.entries(errors).length === 0) {
          // console.log("PASS")
          batch(() => {
            dispatch(updateValidFormData("claimLiabilityDetail", values))
            // dispatch(pageIncrement())
            dispatch(updateClickedNext(pageNumber, false))
          })
          getPolicyInfoAPI(values, dispatch)
        } else {
          // console.log("FAIl")
          Alert.missingInfoAlert()
          policyFormRef.current.submitForm() // Set touched to all fields
          batch(() => {
            dispatch(updateClickedNext(pageNumber, false))
          })
        }
      })
    }
  }, [policyFormRef, values, pageNumber, dispatch, currentPageClickedNext])
  return null
}

const getPolicyInfoAPI = (values, dispatch) => {
  dispatch(controlLoading())

  //Call API to validate liability policy
  const validatePolicyPromise = API.apiPostRequest(
    "/Claim/LiabilityValidatePolicyInfo",
    {
      PolicyNumber: values.policyNumber,
      PolicyHolderName: values.policyHolderName,
    },
    null
  )

  const getLiabilityOptionList = API.apiPostRequest(
    "/Claim/LiabilityOptionList",
    null,
    null
  )

  //Call API to get required documents for Basic coverage
  // const getRequiredDocumentPromise = API.apiPostRequest(
  //   "/Claim/GetRequiredDocumentList",
  //   {
  //     coverageId: basicCoverageDetailId,
  //   },
  //   null
  // )

  //Get Occupation for dropdown field
  // const occupationPromise = API.apiPostRequest("/Claim/Occupation", null, null)

  //Get bank list
  // const banklistPromise = API.apiPostRequest("/Claim/BankList", null, null)

  Promise.all([validatePolicyPromise, getLiabilityOptionList])
    .then(values => {
      // console.log(values)
      // dispatch(controlLoading())
      const validatePolicyResult = values[0].data
      const requiredDocumentResult = values[1].data.RequiredDocuments
      const occupationResult = values[1].data.Occupations
      const emptyBank = [
        {
          Bank_Id: 0,
          Bank_Name: "",
          BIC: "",
          IsValid: true,
          RegexValidation: "",
          RegexValidationJs: "",
          ErrorMessage: "",
        },
      ]
      //const banklistResult = Object.assign(emptyBank, values[1].data.Banks)\
      let banklistResult = null
      if (values[1].data.Banks) {
        banklistResult = [emptyBank].concat(values[1].data.Banks)
      } else {
        banklistResult = emptyBank
      }
      if (
        validatePolicyResult.IsValidPolicyHolder === "N" &&
        validatePolicyResult.UpStatus === "True"
      ) {
        Alert.liabilityPolicyValidationAlert()
        dispatch(controlLoading())
      } else {
        batch(() => {
          dispatch(updateUiData("proofDocuments", requiredDocumentResult))
          dispatch(updateUiData("folderName", generateFolderName()))
          dispatch(updateUiData("occupationList", occupationResult))
          dispatch(updateUiData("bankList", banklistResult))

          dispatch(pageIncrement())
          dispatch(controlLoading())
        })
      }
    })
    .catch(error => {
      navigate("errorOccurred")
    })
}

const generateFolderName = () => {
  let dd = new Date()
  let ss =
    "" +
    dd.getYear() +
    dd.getMonth() +
    dd.getDate() +
    dd.getHours() +
    dd.getMinutes() +
    dd.getSeconds()

  return "Liability_" + ss
}
export default PolicyInformation
